import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { IMaskInput } from "react-imask";
import Modal from "react-modal";
import api from "../../../services/api";
import "./style.css";

Modal.setAppElement("#root");

function Home() {
  const navigate = useNavigate();

  const [cpf, setCpf] = useState("");
  const [nome, setNome] = useState("");
  const [equipe, setEquipe] = useState("");
  const [codEquipe, setCodEquipe] = useState(0);

  const [listaEquipes, setListaEquipes] = useState([]);
  const [loadingEquipe, setLoadingEquipe] = useState(false);

  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState("");

  const [clientes, setClientes] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);

  /* =========================
     AUTOCOMPLETE EQUIPE
  ========================= */
  useEffect(() => {
    async function buscarEquipes() {
      if (equipe.length < 2) {
        setListaEquipes([]);
        return;
      }

      try {
        setLoadingEquipe(true);
        const response = await api.get("v1/filtro/equipe", {
          params: { filtro: equipe },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        });

        setListaEquipes(response.data || []);
      } catch (err) {
        console.log(err);
      } finally {
        setLoadingEquipe(false);
      }
    }

    buscarEquipes();
  }, [equipe]);

  function selecionarEquipe(item) {
    setEquipe(item.nome);
    setCodEquipe(item.codequipe);
    setListaEquipes([]);
  }

  /* =========================
     BUSCAR HISTÓRICO
  ========================= */
  async function BuscarHistorico(e) {
    e.preventDefault();
    setErro("");
    setLoading(true);

    const cpfLimpo = cpf ? cpf.replace(/\D/g, "") : "";

    try {
      const response = await api.get("/v1/consulta", {
        params: {
          cpf: cpfLimpo,
          nome: nome,
          codequipe: codEquipe,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      });

      if (!response.data || response.data.length === 0) {
        setErro("Nenhum cliente encontrado.");
        setLoading(false);
        return;
      }

      // Se vier apenas um cliente, navega direto
      if (response.data.length === 1) {
        selecionarCliente(response.data[0]);
      } else {
        // Se vier mais de um, abre modal
        setClientes(response.data);
        setModalOpen(true);
      }
    } catch (error) {
      console.log(error);
      setErro("Erro ao buscar o cliente. Tente novamente.");
    }

    setLoading(false);
  }

  /* =========================
     SELECIONAR CLIENTE
  ========================= */
  function selecionarCliente(cliente) {
    localStorage.setItem("cpfConsulta", cliente.cpf);
    localStorage.setItem("tempCliente", cliente.nome);
    localStorage.setItem("tempCodCliente", cliente.codcliente);
    localStorage.setItem("tempCodEquipe", cliente.codequipe || 0);

    setModalOpen(false);
    navigate("/cadastro/cliente");
  }

  return (
    <div className="container d-flex justify-content-center align-items-center min-vh-100">
      <div className="col-lg-5 col-md-7 col-sm-11">
        <form className="card p-4 shadow-lg" onSubmit={BuscarHistorico}>
          <h4 className="text-center mb-3">
            <i className="fa-solid fa-magnifying-glass"></i> Consultar Cliente
          </h4>

          {/* CPF */}
          <label className="form-label fw-bold">CPF</label>
          <IMaskInput
            mask="000.000.000-00"
            value={cpf}
            onAccept={(value) => setCpf(value)}
            placeholder="Digite o CPF"
            className="form-control mb-3"
          />

          {/* NOME */}
          <label className="form-label fw-bold">Nome do Cliente</label>
          <input
            type="text"
            className="form-control mb-3"
            placeholder="Digite o nome"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
          />

          {/* EQUIPE */}
          <label className="form-label fw-bold">Equipe</label>
          <input
            type="text"
            className="form-control"
            placeholder="Digite a equipe"
            value={equipe}
            onChange={(e) => {
              setEquipe(e.target.value);
              setCodEquipe(0);
            }}
          />

          {listaEquipes.length > 0 && (
            <div className="list-group position-absolute w-100 z-3">
              {listaEquipes.map((item) => (
                <button
                  type="button"
                  key={item.codequipe}
                  className="list-group-item list-group-item-action"
                  onClick={() => selecionarEquipe(item)}
                >
                  {item.nome}
                </button>
              ))}
            </div>
          )}

          <button
            type="submit"
            className="btn btn-primary w-100 mt-4"
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm"></span>
                <span className="ms-2">Consultando...</span>
              </>
            ) : (
              <>
                <i className="fa-solid fa-search"></i>
                <span className="ms-2">Buscar Histórico</span>
              </>
            )}
          </button>

          {erro && (
            <div className="alert alert-danger mt-3 text-center">
              {erro}
            </div>
          )}
        </form>
      </div>

      {/* ================= MODAL CLIENTES ================= */}
      <Modal
        isOpen={modalOpen}
        onRequestClose={() => setModalOpen(false)}
        overlayClassName="modal-overlay"
        className="modal-content modal-xl modal-clientes"
      >
        <div className="modal-header-custom">
          <h5>Selecione o Cliente</h5>
          <button
            className="btn-close"
            onClick={() => setModalOpen(false)}
          />
        </div>

        {/* ÁREA COM SCROLL */}
        <div className="modal-body-custom">
          {clientes.map((cliente) => (
            <div
              key={cliente.codcliente}
              className="cliente-card"
              onClick={() => selecionarCliente(cliente)}
            >
              <div className="cliente-nome">{cliente.nome}</div>

              <div className="cliente-info">
                <span><strong>CPF:</strong> {cliente.cpf}</span>
                <span><strong>Equipe:</strong> {cliente.equipe}</span>
              </div>

              <div className="cliente-endereco">
                <strong>Endereço:</strong> {cliente.endereco}, {cliente.numero} –{" "}
                {cliente.bairro} – {cliente.cidade}/{cliente.uf}
              </div>
            </div>
          ))}
        </div>

        <div className="modal-footer-custom">
          <button
            className="btn btn-secondary w-100"
            onClick={() => setModalOpen(false)}
          >
            Cancelar
          </button>
        </div>
      </Modal>

    </div>
  );
}

export default Home;
